import React from "react";
import * as XLSX from "xlsx";
import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

export function createWorkbook(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const readData = e.target.result;
      const data = new Uint8Array(readData);
      if (data.length > 10e6) {
        reject("Input file length is too large.");
      }
      try {
        const workbook = XLSX.read(data, {
          type: "array",
          cellDates: true,
          UTC: true,
          dateNF: "yyyy-mm-dd",
        });
        resolve(workbook);
      } catch (e) {
        reject(e);
      }
    };
    reader.readAsArrayBuffer(file);
  });
}

export function createTable(workbook) {
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  return XLSX.utils.sheet_to_json(sheet, { raw: false });
}

export const TemplateFile = ({ headers, fileName = "" }) => {
  const exportXLSX = () => {
    const worksheet = XLSX.utils.aoa_to_sheet([headers]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Planilha1");

    XLSX.writeFile(workbook, `Template_${fileName}.xlsx`);
  };
  return (
    <Button type="primary" key="template" onClick={exportXLSX}>
      Baixar modelo <DownloadOutlined />
    </Button>
  );
};
